import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  button: {
    cursor: "pointer",
  },
}));

export default styles;
